import { useEffect, useState } from 'react';

import MarketingHeader from '@/pages/(marketing)/index/components/Header';
import { hasLikelyValidToken } from '@/renderer/utils/useMe';

/**
 * Standard chrome for public, shareable "in-app" content landings (e.g. /order,
 * /app). Drop it at the very top of such a page's +Page.tsx.
 *
 * The layout convention for these routes is header-vs-sidebar-by-auth:
 *   • Signed-out visitor → marketing header (this component) + footer, so they
 *     always have a way to navigate.
 *   • Signed-in user     → the app sidebar (renderer/Nav) carries navigation, so
 *     the marketing header is suppressed to avoid a redundant double header.
 *
 * This component owns the header half. Nav (renderer/Nav.tsx) owns the sidebar
 * half: it hides the sidebar for signed-out visitors on these routes (see
 * MARKETING_LANDING_ROUTES there) and shows it for signed-in users.
 *
 * New public landings should reuse this component instead of rendering a bare
 * logo and instead of adding the route to Nav's HIDE_ON list — HIDE_ON removes
 * the sidebar for *everyone*, which strands signed-in app users with no
 * navigation (the /app regression, issue #1405).
 */
export default function MarketingHeaderSlot() {
  // Starts false so SSR and the first client render agree (header shown), then
  // resolves after mount — the same post-hydration pattern the sidebar uses.
  const [likelyLoggedIn, setLikelyLoggedIn] = useState(false);
  useEffect(() => {
    setLikelyLoggedIn(hasLikelyValidToken());
  }, []);

  if (likelyLoggedIn) {
    return null;
  }

  return <MarketingHeader absolute={false} />;
}
